/**
 * @Author : zhouqinze
 * @Date : 2019-12-27
 * @Version : 1.0
 * @Content : 首页底部
 **/
<template>
    <div class="footer">
        <div class="footerCon">
            <div class="content">
                <div class="footText">
                    <h3>官方互动</h3>
                    <p>工作时间（周一至周六9：00-18：00）</p>
                    <p>电话：020-38481073</p>
                    <p>邮编：510653</p>
                    <p>电子邮箱：cyw@comit.com.cn</p>
                </div>
                <div class="footCode">
                    <div><img src="../assets/img/img_tyewm.png" alt=""><p>通易公众号</p></div>
                    <!-- <div><img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_tyewm.png" alt=""><p>通易公众号</p></div> -->
                    <div><img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_yjewm.png" alt=""><p>优驾公众号</p></div>
                </div>
            </div>
        </div>
        <div class="footerBtm">
            <div class="content">
                <p>© 2021 广州通易科技有限公司 版权所有 <a target="_blank" href="https://beian.miit.gov.cn">粤ICP备05058967号</a></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    .footer{
        width: 100%;
        .footerCon{
            width: 100%;
            height: 18.0625rem;
            background: #f2f2f2;
            .content{
                width: 75rem;
                height: 100%;
                margin: auto;
                display: flex;
                padding: 0 6.25rem;
                box-sizing: border-box;
                justify-content: space-between;

                .footText{
                    text-align: left;
                    margin-top: 3.625rem;
                    color: #444;
                    h3{
                        font-size: 1.125rem;
                        line-height: 1.125rem;
                        margin-bottom: 2.5625rem;
                        // font-family:Source Han Sans CN;
                    }
                    p{
                        font-size: .875rem;
                        line-height: .875rem;
                        margin-bottom: 1.1875rem;
                    }
                    p:last-child{
                        margin-bottom: 0;
                    }
                }
                .footCode{
                    margin-top: 3.8125rem;
                    display: flex;
                    div{
                        img{
                            width: 9.625rem;
                            height: 9.625rem;
                            margin-bottom: .5625rem;
                        }
                        p{
                            color: #444;
                            font-size: .875rem;
                        }
                    }
                    div:first-child{
                        margin-right: 4.9375rem;
                    }
                }
            }
        }
        
        a, a:hover, a:visited, a:link, a:active {
            text-decoration: none;
            color: #888888;
        }
        .footerBtm{
            width: 100%;
            height: 5.4375rem;
            background: #202020;
            .content{
                width: 75rem;
                height: 100%;
                margin: auto;
                p{
                    
                    color: #808080;
                    font-size: .875rem;
                    line-height: 5.4375rem;
                    // font-family:SimSun;
                    // font-weight:400;
                    
                }
            }
        }
    }
</style>